import React from 'react';

interface IProps {
  fillColor?: string;
}

const MoveCenterIcon:React.FC<IProps> = (props) => {
  return (
    <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M6.90847 0C7.33241 0 7.67608 0.34367 7.67608 0.767608V4.98945H12.6655C13.3014 4.98945 13.8169 5.50495 13.8169 6.14086V10.7465C13.8169 11.3824 13.3014 11.8979 12.6655 11.8979H7.67608V16.1198C7.67608 16.5437 7.33241 16.8874 6.90847 16.8874C6.48453 16.8874 6.14086 16.5437 6.14086 16.1198V11.8975L1.15141 11.8979C0.515504 11.8979 0 11.3824 0 10.7465V6.14086C0 5.50495 0.515504 4.98945 1.15141 4.98945L6.14086 4.98907V0.767608C6.14086 0.34367 6.48453 0 6.90847 0Z" fill={props.fillColor ?? "#424C57"}/>
    </svg>
  )
}

export default MoveCenterIcon;
